<template>
  <div>
    <div class="seachBox flex">
      <div class="seachList"><span class="name">客户名称：</span>
        <a-select
          placeholder="请输入客户名称"
          v-model="seach.id" class="seachs"
          :default-active-first-option="false"
          :filter-option="false"
          :not-found-content="null"
          :options="options"
          :show-arrow="false"
          show-search
          @search="handleSearch"
          @change="searchFn"
        >
        </a-select>
      </div>
    </div>
    <div v-if="loading === false">
      <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id"></a-table>
      <a-tabs v-model="tabIndex" type="card" @change="tabsChange">
        <a-tab-pane
          v-for="item in tabList"
          :key="item.key"
          :tab="item.tab"
        ></a-tab-pane>
      </a-tabs>
      <div v-if="tabIndex === 1">
        <h1>
          新增导入
          <a-button class="top_btn" style="margin-left: 15px;" type="primary" @click="()=>{visible = true; }">整站导入</a-button>
        </h1>
        <h1>
          <a-link style="cursor: pointer;" type="primary" @click="getList(1)">导入日志</a-link>
        </h1>
        <a-table :columns="columns2" :data-source="data2" :loading="loading2" :pagination="false" rowKey="id" :scroll="{ x: 1100 }">
          <span slot="status" slot-scope="text, record">{{ record.status_text }}
            <!--<a-popconfirm
                  title="是否重新提交？"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="addAlibaba(record)"
                  @cancel="()=>{}"
              >
                <a v-if="record.status==3">重新提交</a>
              </a-popconfirm>-->
          </span>
          <span slot="action" slot-scope="text">
            <a class="red" v-if="text.status==2" @click="delLog(text.id)">删除</a> 
            <a v-else disabled>删除</a>
          </span>
        </a-table>
      </div>
      <div v-if="tabIndex === 2">
        <ProductImport ref="productImportRef" :seachData="seach"></ProductImport>
      </div>
    </div>
    <a-modal
      title="导入第三方产品"
      :visible="visible"
      @ok="addAlibaba()"
      @cancel="cancelAL"
    >
      <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
        <a-form-model-item
          ref="platform_type"
          label="店铺类型"
          prop="platform_type"
        >
          <a-select v-model="form.platform_type" class="seachs" allowClear placeholder="请选择" @change="(e) => { formErr.store_url=''}">
            <a-select-option :value="item.id" :key="index" v-for="(item,index) in platformTypeList">
              {{item.name}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          ref="store_url"
          label="店铺地址"
          prop="store_url"
          :help="formErr.store_url"
          :validateStatus='!formErr.store_url || formErr.store_url === "" ? "" : "error"'
        >
          <a-input
            :maxLength=255
            placeholder="http://"
            v-model="form.store_url"
            @change="(e) => { formErr.store_url=''}"
            @blur="(e) => { form.store_url = e.target.value.trim() }"
          />
        </a-form-model-item>
      </a-form-model>
      <div style="position: relative">
        <span style="position: absolute;top: 0;left: 0">注：</span>
        <div style="padding-left: 30px">1.请输入{{form.platform_type === 1 ? '阿里' : 'Made in China'}}店铺链接地址:店铺首页或productlist页面</div>
        <div style="padding-left: 30px">
          2.导入后图片水印跟随用户后台“产品管理-水印设置”，如果不想添加水印，请关闭水印，如果想要添加水印，请开启并上传水印
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import API from "./api";
import AgentForm from "./components/agentForm"
import ProductImport from "./components/productImport"
import {debounce, validator} from "@/utils/utils"

const columns = [
  {
    title: "客户名称",
    dataIndex: "company",
    ellipsis: true,
    key: "company",
  },
  {
    title: "手机号",
    dataIndex: "mobile",
    ellipsis: true,
    key: "mobile",
    scopedSlots: {customRender: "mobile"}
  },
  {
    title: "网址",
    dataIndex: "domain",
    ellipsis: true,
    key: "domain", scopedSlots: {customRender: "domain"}
  },
];
const columns2 = [
  {
    title: "导入内容",
    dataIndex: "store_url",
    ellipsis: true,
    key: "store_url",
    width: "500px",
  },
  {
    title: "导入平台",
    dataIndex: "platform_type_text",
    ellipsis: true,
    key: "platform_type_text",
    width: "100px",
  },
  {
    title: "提交时间",
    dataIndex: "commit_time",
    ellipsis: true,
    key: "commit_time",
    scopedSlots: {customRender: "commit_time"},
    width: "150px",
  },
  {
    title: "导入完成时间",
    dataIndex: "finish_time",
    ellipsis: true,
    key: "finish_time", scopedSlots: {customRender: "finish_time"},
    width: "150px",
  },
  {
    title: "状态",
    dataIndex: "status_text",
    ellipsis: true,
    key: "status_text", scopedSlots: {customRender: "status"},
    width: "100px",
  },
  {
    title: "导入数量",
    dataIndex: "import_num",
    ellipsis: true,
    key: "import_num", scopedSlots: {customRender: "import_num"},
    width: "100px",
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: {customRender: "action"},
    width: "100px",
  },
];
export default {
  name: "index",
  data() {
    return {
      layout: {
        labelCol: {span: 4},
        wrapperCol: {span: 18},
      },
      store_url: "",
      form: {
        platform_type: 1,
        store_url: ""
      },
      formErr: {
        platform_type: "",
        store_url: ""
      },
      rules: {
        platform_type: [
          {
            required: true,
            message: "请选择店铺类型",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.platform_type)
            }, trigger: "blur"
          },
        ],
        store_url: [
          {
            required: true,
            message: "请输入店铺地址",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.store_url)
            }, trigger: "blur"
          },
        ],
      },
      //这里的id值对应数据库xb_a_alibaba_import表的platform_type字段。改动不大，写死数组了，就不从后台接口取了。
      platformTypeList: [
        {'id' : 1, 'name' : '阿里巴巴'},
        {'id' : 2, 'name' : 'Made in China'},
      ],
      options: [],
      seach: {id: undefined,},
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true
      },
      data: [],
      data2: [],
      columns,
      columns2,
      loading: true,
      loading2: true,
      visible: false,
      title: "",
      editId: null,
      tabIndex:1,
      tabList: [
        {
            key: 1,
            tab: "整站导入"
        },
        {
            key: 2,
            tab: "产品导入"
        }
      ]
    }
  },
  created() {
    //设置左侧导航2-2 active
    this.$store.state.adminleftnavnum = "/Agent/AgentList";
  },
  mounted() {
  },
  // eslint-disable-next-line vue/no-unused-components
  components: {AgentForm,ProductImport},
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },
  methods: {
    cancelAL() {
      this.visible = false;
      if (this.$refs.ruleForm) this.$refs.ruleForm.resetFields();
    },
    addAlibaba(record) {
      let _that = this
      if (record) {
        API.service.SUBMIT_ADD({platform_type: record.platform_type, store_url: record.store_url, a_customer_id: _that.seach.id}).then(() => {
          _that.getList()
        })
      } else {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            API.service.SUBMIT_ADD({platform_type: _that.form.platform_type, store_url: _that.form.store_url, a_customer_id: _that.seach.id}).then(res => {
              if (res.data.code === 400) {
                res.data.msg.map((item) => {
                  _that.formErr[item.field] = item.msg
                })
              } else {
                _that.getList()
              }
            })
          }
        })
      }
    },
    handleSearch: debounce(function (val) {
      this.handleSearchFn(val)
    }, 300),
    handleSearchFn(val) {
      this.options = [];
      //下拉模糊查询
      if (val) {
        this.getSeachList(val)
      }
    },
    getSeachList(company) {
      API.service.GET_NAME({company}).then(res => {
        // this.seachList.name = res.data.data
        res.data.data.forEach((item) => {
          this.options.push({
            value: item.id,
            label: item.company,
          })
        });
      })
    },
    searchFn() {
      let _that = this
      if(_that.tabIndex === 1) {
        _that.getList(1)
      } else {
        _that.$refs.productImportRef.getList();
      }
    },
    tabsChange(val) {
      let _that = this
      if(val === 1) {
        _that.getList(1)
      } else {
        _that.$refs.productImportRef.getList();
      }
    },
    getList(page) {
      this.loading2 = true
      let seachData = JSON.parse(JSON.stringify(this.seach))
      API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
        this.data = [res.data.data]
        this.loading = false
        this.loading2 = false
      })
      API.service.GET_RECORD({page: page || 1, a_customer_id: this.seach.id}).then(res => {
        this.data2 = res.data.data
        this.loading = false
        this.loading2 = false
      })
      this.visible = false;
     if(this.$refs.ruleForm)this.$refs.ruleForm.resetFields();
    },
    delLog(id) {
      API.service.DELE({id}).then(res => {
        this.getList()
      })
    },
  }
}
</script>
<style scoped>
.seachBox .seachList .name {
  width: 70px !important;
}
.seachBox .seachList .seachs {
  width: calc(100% - 80px);
}
.inputs {
  display: inline-block;
  width: 70px
}
h1 {
  font-size: 16px;
  font-weight: bold
}
.ant-table-body {
  min-height: unset !important;
}
.red {
  color: #f56c6c;
}
</style>
